import { cancelamento } from "@/http/cancelar/cancelar.services"
import { ComposableDePermissionamento } from "@/composable/UsarPermissionamento/usarPermissionamento"
import { OperacaoDePermissionamento } from "@/composable/UsarPermissionamento/modulosDePermissao"
import { NavigationGuardNext, RouteLocationNormalized } from "vue-router"
import SessaoServico from "@/servicos/sessao.service"
import { Grupos, OperadorLogico } from "@/types/gerais"

type Params = {
  to: RouteLocationNormalized
  from: RouteLocationNormalized
  next: NavigationGuardNext
}

type ChecarPermissaoParams = {
  permissoes: string[]
  permissionamento: ComposableDePermissionamento
  operador: OperadorLogico
}

export const mapGuards = {
  auth: ({ to, from, next }: Params) => {
    const naoEstaAutenticado = !SessaoServico.autenticado
    const naoEstaAcessandoTelaDeLogin = to.name !== "Login"

    if (naoEstaAutenticado && naoEstaAcessandoTelaDeLogin) {
      return next({ name: "Login" })
    }
  },
  livre: () => {
    return true
  },
  cancelador: () => {
    cancelamento.cancelarRequisicoesPendentes()
  },
  checarPermissao: ({
    permissoes,
    permissionamento,
    operador = "e",
  }: ChecarPermissaoParams) => {
    const { verificarPermissaoPorGrupo } = permissionamento
    const respostasSobreCadaPermissao = permissoes.map((permissao) => {
      const [nomePermissao, grupo] = permissao.split(":")
      return verificarPermissaoPorGrupo(
        nomePermissao as OperacaoDePermissionamento,
        grupo as Grupos
      )
    })

    if (operador === "e") {
      return respostasSobreCadaPermissao.every((resultado) => resultado)
    }
    if (operador === "ou") {
      return respostasSobreCadaPermissao.some((resultado) => resultado)
    }
    return true
  },
}
